/*
 * @Description:
 * @Date: 2020-09-21 15:41:18
 */

import Vue from 'vue';
import { kernel } from '@/utils/tools.js';
import { jsApiSignature } from '@/api/ajax';
import { getStorage } from '@/utils/storage';
import config from '@/config/index';
import wx from 'weixin-js-sdk';

export default async args => {
  let defaultArg = {
    title: '',
    link: window.location.href,
    target: '',
    imgUrl: '',
    desc: '',
    callback: null
  };
  Object.assign(defaultArg, args);
  let { title, link, target, imgUrl, desc, callback } = defaultArg;
  // alert(target, link);
  let shareUrl = target || link;
  if (kernel() === 'wx') {
    let {
      data: {
        data: { appId, timestamp, nonceStr, signature }
      }
    } = await jsApiSignature({ url: link });
    wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'previewImage',
        'openLocation',
        'getLocation'
      ]
    });
    wx.ready(function () {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      wx.onMenuShareTimeline({
        title, // 分享标题
        link: shareUrl, // 分享链接
        imgUrl, // 分享图标
        success: function () {
          if (callback) {
            callback();
          }
        },
        cancel: function () {}
      });

      wx.onMenuShareAppMessage({
        title, // 分享标题
        link: shareUrl, // 分享链接
        imgUrl, // 分享图标
        desc, // 分享描述
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          if (callback) {
            callback();
          }
        },
        cancel: function () {}
      });
    });
  }
};
